import React, { useEffect } from "react";
//import { rubros } from "../../json/rubrosSesa";
import "./rubrosSesa.css";
import { Link } from "react-router-dom";
const res = await fetch('/JSON/rubrosSesa.json')
const rubros = await res.json()

const RubrosSesa = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="container">
      <div className="row">
        <div className="rubros_titulo">
          <h2>
            Articulo 69 Ley de Transparencia (48 Rubros Secretaria de Salud)
          </h2>
        </div>
        {rubros.map((item, index) => (
          <Link
            key={index}
            to={item.url ? item.url : "DetalleRubroSesa/" + item.nombre}
            className="col-md-4 col-sm-6 col-12 rubro_enlace"
          >
            <div className="rubro_container">
              <div className="rubro_icono">
                <img
                  src={
                    "http://cdn.hidalgo.gob.mx/plantilla_secretarial/Rubros/PNG/" +
                    item.icono
                  }
                />
              </div>
              <h3>{item.nombre}</h3>
            </div>
          </Link>
        ))}
        <Link className="rubros_historicos" to="RubrosHistoricosSesa">
          Información Ejercicios Anteriores Art. 69 (48 Fracciones)
        </Link>
      </div>
    </div>
  );
};

export default RubrosSesa;
